// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#app {\n  font-family: \"PingFang SC\", \"Microsoft YaHei\",Arial,sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* text-align: center; */\n  color: #333333;\n  /* margin-top: 60px; */\n  height: 100%;\n  background: #fafafa;\n}\n* {\n  margin: 0;\n  padding: 0;\n}\n.el-picker-panel__footer .el-button--text.el-picker-panel__link-btn {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
